import React from 'react';
import '../../css/LeaveQuota.css';
import { useTranslation } from 'react-i18next';

const LeaveTypes = ({ data, language }) => {
    const { t } = useTranslation();

    return (
        <div className="w-100">
            {data && data.length > 0 ? (
                <>
                    <div>{t('Please select the type of leave.')}</div>
                    <ol>
                        {data.map((leave, index) => (
                            <li key={index}>{leave.AbsenceTypeName}</li>
                        ))}
                    </ol>
                </>
            ) : (
                <p>{t("Sorry, you don't have leave types available")}</p>
            )}
        </div>
    );
};

export default LeaveTypes;
